import React from "react";
import DataTable from "@/components/DataTable";
import Icon from "@/components/Icon";
import intl from "react-intl-universal";
import { Button, Popconfirm, Popover } from "antd";
import * as DICT from "@/utils/dict";
import Purview from "@/components/Purview";
import styles from "./columns.module.less";
import Tag from "@/components/Tag";
import PopoverButton from "@/components/Popover";

export default (self, initialValue) => {
  let ret = [
    {
      title: "所属机构",
      name: "id",
      searchItem: {
        placeholder: "所属机构",
        type: "treeSelect",
        group: "mini",
        width: "1.8rem",
        // group: "advance",
        showSearch: false,
        name: "id",
        treeData: self.props.unitListOnlyOrgans,
      },
    },
    {
      title: "单位名称",
      name: "name",
      tableItem: {
        width: `4rem`,
        ellipsis: true,
      },
      searchItem: {
        placeholder: "单位名称",
        width: `2rem`,
        group: "mini",
      },
    },
    {
      title: "单位类型",
      name: "category",
      tableItem: {
        width: `3rem`,
        render: (text, record) => DICT.getValue("PROJECT_CATEGORY", text),
      },
      searchItem: {
        type: "select",
        placeholder: "单位类型",
        group: "mini",
        width: "1.8rem",
        dict: DICT.getList("PROJECT_CATEGORY"),
        initialValue: initialValue.category,
      },
    },
    {
      title: "机构名称",
      name: "organsName",
      tableItem: {
        width: `4rem`,
      },
    },
    {
      title: "详情",
      name: "state",
      tableItem: {
        render: (text, record) => {
          let tags = [
            // <Tag
            //   className={styles.tag}
            //   color={`GOLD6`}
            //   onClick={(e) => {
            //     self.onShowLeader(record);
            //   }}
            // >{`负责人 : ${record.leaderTotal}`}</Tag>,
            <Tag
              className={styles.tag}
              color={`VOLCANO6`}
              onClick={(e) => {
                self.showUserManage(record);
              }}
            >{`用户 : ${
              record.userList && record.userList.length > 0
                ? record.userList.length
                : 0
            }`}</Tag>,
            // <Tag
            //   className={styles.tag}
            //   color={`CYAN6`}
            //   onClick={(e) => {
            //     self.onShowFloorImg(record);
            //   }}
            // >{`平面图 : ${record.planeTotal}`}</Tag>,
            <Tag
              className={styles.tag}
              color={`BLUE6`}
              onClick={(e) => {
                self.deviceChange(record);
              }}
            >{`设备 : ${record.deviceTotal}`}</Tag>,
          ];
          if (record.share) {
            tags.push(
              <Tag
                className={styles.tag}
                color={`ORANGE6`}
                onClick={(e) => {
                  self.unitShare(record);
                }}
              >
                分享
              </Tag>
            );
          }
          return <div className={styles.tags}>{tags}</div>;
        },
      },
    },
    {
      title: "分享",
      name: "share",
      searchItem: {
        width: "1.8rem",
        group: "mini",
        placeholder: "查看分享单位",
        type: "select",
        dict: [
          { code: "onlyShare", codeName: "只看分享" },
          { code: "onlyUnit", codeName: "不看分享" },
        ],
      },
    },
    {
      title: "直属单位",
      name: "currentSubUnit",
      searchItem: {
        placeholder: "直属单位",
        type: "Switch",
        width: "0.8rem",
        name: "currentSubUnit",
      },
    },
  ];
  return ret;
};
